import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { isEmpty } from 'lodash'

import CartItems from '../containers/CartItems'
import CartDetails from '../containers/CartDetails'
import Button from './Button'
import TabOrderCartDetails from '../components/tabs/TabOrderCartDetails'
import CardReaderModal from '../containers/CardReaderModal'

import styles from './CartSidebar.module.scss'

const CartSidebar = ({ clearCart, topButton, bottomButton, showCardReaderModal, onCardReaderModalClose, hasCartItems, order, className }) => {
  const classNames = cn(styles.cartSidebar, className)
  const isTab = !isEmpty(order)
  let modal = null
  let cartFooterElement = null

  if (showCardReaderModal) {
    modal = (
      <CardReaderModal
        onClose={() => {
          onCardReaderModalClose(false)
        }}
      />
    )
  }

  if (hasCartItems) {
    cartFooterElement = (
      <div className={styles.cartDetailsContainer}>
        <CartDetails
          className={styles.cartDetails}
          order={order}
          lineItemPrefix={isTab ? 'new' : ''}
        />
        <Button
          className={styles.checkout}
          disabled={topButton.disabled}
          onClick={topButton.onClick}
        >{topButton.text}</Button>
        {bottomButton && <Button
          className={styles.checkout}
          disabled={bottomButton.disabled}
          onClick={bottomButton.onClick}
        >{bottomButton.text}</Button>}
        {/* TODO: Add this back when we are ready. The button placement is problematic. */}
        {/* <GradientButton
          text="clear cart"
          className={styles.clearCart}
          onClick={clearCart}
        /> */}
      </div>
    )
  }

  return (
    <div className={classNames}>
      {isTab && <TabOrderCartDetails order={order} hasCartItems={hasCartItems}/>}
      <CartItems className={styles.cartItems} />
      {cartFooterElement}
      {modal}
    </div>
  )
}

CartSidebar.defaultProps = {
  clearCart: () => {},
  order: {},
}

CartSidebar.propTypes = {
  clearCart: PropTypes.func,
  hasCartItems: PropTypes.bool,
  className: PropTypes.string,
  order: PropTypes.object
}

export default CartSidebar
